import type { SVGProps } from "react";

/**
 * arrow-up,arrow-top
 * @category Arrows
 */
export default function IconArrowUp(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M5.75 10L12 3.75L18.25 10M12 20.25V4.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
